import React, { useState, lazy } from 'react';
import { ExternalLinkIcon, XIcon } from 'lucide-react';
const IframeModal = ({
  isOpen,
  onClose,
  url,
  title
}: {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  title: string;
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-123">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl h-[90vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-124">
        <div className="bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between shrink-0" data-id="element-125">
          <h2 className="text-lg font-bold text-benefika-charcoal" data-id="element-126">{title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-benefika-teal transition-colors bg-gray-50 hover:bg-benefika-teal/10 p-2 rounded-full" aria-label="Cerrar" data-id="element-127">
            <XIcon size={20} data-id="element-128" />
          </button>
        </div>
        <iframe src={url} title={title} className="flex-1 w-full border-0" loading="lazy" data-id="element-129" />
      </div>
    </div>;
};
const Footer = () => {
  const [modal, setModal] = useState<{
    url: string;
    title: string;
  } | null>(null);
  return <>
      <footer className="bg-benefika-charcoal text-white pt-20 pb-10 border-t-4 border-benefika-teal" data-id="element-130">
        <div className="container mx-auto px-4" data-id="element-131">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-132">
            <div className="md:col-span-4" data-id="element-133">
              <div className="flex flex-col items-start mb-6" data-id="element-134">
                <img src="https://cdn.magicpatterns.com/uploads/pNtwX8Jp3E6Vy5TGdP2c2t/logo_benefica_negativo.png" alt="Benefika" className="h-10 w-auto" data-id="element-135" />
              </div>
              <p className="text-gray-400 mb-8 leading-relaxed pr-4" data-id="element-136">
                Soluciones innovadoras de fidelización para potenciar la
                relación con sus clientes, usuarios o grupos de interés y
                transformar transacciones en lealtad a largo plazo.
              </p>
            </div>

            <div className="md:col-span-2 md:col-start-6" data-id="element-137">
              <h3 className="font-bold text-lg mb-6 text-white" data-id="element-138">Empresa</h3>
              <ul className="space-y-3" data-id="element-139">
                <li data-id="element-140">
                  <a href="/nosotros" className="text-gray-400 hover:text-benefika-teal transition-colors" data-id="element-141">
                    Sobre Nosotros
                  </a>
                </li>
                <li data-id="element-142">
                  <a href="/#caracteristicas" className="text-gray-400 hover:text-benefika-teal transition-colors" data-id="element-143">
                    ¿Por qué elegirnos?
                  </a>
                </li>
                <li data-id="element-144">
                  <a href="/programas-clientes" className="text-gray-400 hover:text-benefika-teal transition-colors" data-id="element-145">
                    Casos de Éxito
                  </a>
                </li>
              </ul>
            </div>

            <div className="md:col-span-3" data-id="element-146">
              <h3 className="font-bold text-lg mb-6 text-white" data-id="element-147">
                Sobre TicketMaestro
              </h3>
              <ul className="space-y-3" data-id="element-148">
                <li data-id="element-149">
                  <a href="https://www.ticketmaestro.net/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-benefika-teal transition-colors inline-flex items-center gap-1.5" data-id="element-150">
                    Ir a TicketMaestro
                    <ExternalLinkIcon size={14} data-id="element-151" />
                  </a>
                </li>
                <li data-id="element-152">
                  <button onClick={() => setModal({
                  url: 'https://www.ticketmaestro.net/privacidad?embed=true',
                  title: 'Privacidad y Protección de Datos'
                })} className="text-gray-400 hover:text-benefika-teal transition-colors text-left" data-id="element-153">
                    Privacidad y Protección de Datos
                  </button>
                </li>
                <li data-id="element-154">
                  <button onClick={() => setModal({
                  url: 'https://www.ticketmaestro.net/terminos?embed=true',
                  title: 'Términos y Condiciones'
                })} className="text-gray-400 hover:text-benefika-teal transition-colors text-left" data-id="element-155">
                    Términos y Condiciones
                  </button>
                </li>
              </ul>
            </div>

            <div className="md:col-span-3" data-id="element-156">
              <h3 className="font-bold text-lg mb-6 text-white" data-id="element-157">Contacto</h3>
              <ul className="space-y-3" data-id="element-158">
                <li data-id="element-159">
                  <a href="mailto:contacto@benefika.net" className="text-gray-400 hover:text-benefika-teal transition-colors flex items-center" data-id="element-160">
                    contacto@benefika.net
                  </a>
                </li>
                <li className="text-gray-400 pt-2" data-id="element-161">
                  Edificio The Point, Of. 1803
                  <br data-id="element-162" />
                  Guayaquil, Ecuador
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-163">
            <p data-id="element-164">
              &copy; {new Date().getFullYear()} Benefika. Todos los derechos
              reservados.
            </p>
            <p className="mt-2 md:mt-0" data-id="element-165">Una marca de TicketMaestro</p>
          </div>
        </div>
      </footer>

      <IframeModal isOpen={modal !== null} onClose={() => setModal(null)} url={modal?.url ?? ''} title={modal?.title ?? ''} data-id="element-166" />
    </>;
};
export default Footer;